<template>
    <!-- Texto largo con contador y control de datos de contacto -->
    <div :class="['ee-field', 'ee-ed-tx', { 'is-invalid': !!error }]">
        <div class="ee-control">
            <textarea :id="id" ref="area" placeholder=" " :maxlength="max" rows="4" :aria-describedby="`${id}-h`" :aria-invalid="String(!!error)" :value="value" @input="alEscribir"></textarea>
            <label :for="id">{{ label }}</label>
        </div>
        <p :id="`${id}-h`" class="ee-hint ee-ed-tx-h"><span>{{ ayuda }}</span><span class="ee-ed-cnt">{{ (value || '').length }}/{{ max }}</span></p>
        <p class="ee-error" role="alert">{{ error }}</p>
    </div>
</template>

<script>
import { CONTACTO } from './datos';

export default {
    name: 'EeTexto',
    props: {
        id: { type: String, required: true },
        label: { type: String, required: true },
        value: { type: String, default: '' },
        ayuda: { type: String, default: '' },
        max: { type: Number, default: 1500 },
    },
    data() { return { tocado: false }; },
    computed: {
        error() {
            if (!this.tocado) return '';
            return this.mensaje(this.value);
        },
    },
    methods: {
        mensaje(v) {
            if (!String(v || '').trim()) return this.$t('editor_espacio.err.required');
            if (CONTACTO.test(v)) return this.$t('editor_espacio.err.contact');
            return '';
        },
        alEscribir(e) { this.tocado = true; this.$emit('input', e.target.value); },
        /** La llama la página al guardar: marca el error y devuelve si está bien. */
        validar() { this.tocado = true; return !this.mensaje(this.value); },
        focus() { this.$refs.area && this.$refs.area.focus({ preventScroll: true }); },
    },
};
</script>
